import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { cancelAccountDeletion, getAccountDeletionDetails } from "core/features/profile/api";
import { profileKeys } from "core/features/profile/hooks";

export default function ReactivationPage() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [deadline, setDeadline] = useState<string>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    getAccountDeletionDetails().then(({ data }) => setDeadline(data.purge_after)).catch(() => {});
  }, []);

  const reactivate = async () => {
    setLoading(true);
    setError("");
    try {
      await cancelAccountDeletion();
      await queryClient.invalidateQueries({ queryKey: profileKeys.details() });
      navigate("/", { replace: true });
    } catch (err: any) {
      setError(err?.response?.data?.message || "We couldn't reactivate your account. Please try again.");
      setLoading(false);
    }
  };

  return <main className="flex min-h-screen items-center justify-center bg-gray-50 dark:bg-dark-700 p-6"><div className="w-full max-w-lg rounded-2xl bg-surface p-8 text-center shadow-sm">
    <h1 className="text-2xl font-semibold text-content">Reactivate your account</h1>
    <p className="mt-3 text-content-secondary">Your account is scheduled for deletion. Reactivate it now to keep using Merko.</p>
    {deadline && <p className="mt-4 text-sm text-content-muted">Permanent deletion is scheduled for {new Date(deadline).toLocaleString()}.</p>}
    {error && <p className="mt-4 text-sm font-medium text-red-600 dark:text-red-300" role="alert">{error}</p>}
    <button type="button" disabled={loading} onClick={reactivate} className="mt-7 inline-flex items-center gap-2 rounded-lg bg-indigo-600 px-5 py-2.5 font-medium text-white disabled:opacity-60">{loading && <Loader2 className="h-4 w-4 animate-spin" />} Reactivate my account</button>
  </div></main>;
}
